export const translations = {
  tr: {
    nav: {
      expertise: 'Uzmanlık',
      caseStudies: 'Referanslar',
      insights: 'Insights',
      about: 'Hakkımızda',
      contact: 'İletişim'
    },
    hero: {
      headline: 'Fikirleri',
      headlineHighlight: 'Akıllı Yazılımlara',
      headlineSuffix: 'Dönüştürüyoruz',
      tagline: '',
      subtext: 'Yapay zekâ destekli SaaS ürünleri, MVP\'ler ve iş sistemleri geliştiriyoruz. Startup\'lar ve kurumsal şirketler için ölçeklenebilir yazılım çözümleri.',
      cta1: 'Referansları İncele',
      cta2: 'İletişime Geç'
    },
    value: {
      title: 'Değer Önerimiz',
      description: 'DATEX SYSTEMS, yapay zekâ entegrasyonları, finansal sistemler ve iş platformları geliştiren mühendislik odaklı bir yazılım şirketidir. Sadece yazılım üretmez, iş mantığını çözer ve sürdürülebilir sistemler kurar.'
    },
    expertise: {
      title: 'Uzmanlık Alanları',
      subtitle: 'Karmaşık iş problemlerini çözen yapay zekâ destekli sistemler geliştiriyoruz.',
      items: [
        {
          title: 'AI & Tahminleme Sistemleri',
          description: 'Olasılıksal modeller, tahminleme motorları ve karar destek mimarileri.'
        },
        {
          title: 'SaaS & MVP Geliştirme',
          description: 'Konsept doğrulamadan üretim kalitesinde ölçeklenebilir sistemlere.'
        },
        {
          title: 'Finansal Yazılımlar',
          description: 'Risk modelleme, algoritmik mantık ve veri yoğun mimariler.'
        },
        {
          title: 'Dijital Varlık & Trading Sistemleri',
          description: 'Dijital piyasalar için trading mantığı, işlem akışları ve risk bilinçli mimariler.'
        },
        {
          title: 'Analitik & Dashboard',
          description: 'Gerçek zamanlı zekâ ve karar destek arayüzleri.'
        },
        {
          title: 'AI & LLM Entegrasyonları',
          description: 'GPT/LLM destekli muhakeme ve bağlam bilinçli sistem tasarımı.'
        }
      ]
    },
    focusAreas: {
      title: 'Uzmanlık Alanları',
      subtitle: 'AI, finansal sistemler ve veri odaklı iş platformlarının kesişim noktasında çalışıyoruz.',
      items: ['AI & Tahminleme Sistemleri', 'Finansal & Trading Teknolojileri', 'Dijital Varlık Piyasaları', 'Veri & Analitik']
    },
    caseStudies: {
      title: 'Gerçek Sistemler',
      titleHighlight: 'Gerçek Çözümler',
      subtitle: 'Farklı sektörlerde geliştirdiğimiz platformlar ve AI destekli yazılım çözümleri.',
      projects: [
        {
          name: 'Borsamex',
          category: 'AI & Finans',
          description: 'AI destekli finansal tahminleme ve analiz platformu'
        },
        {
          name: 'DatexTrader',
          category: 'Fintech',
          description: 'Finansal sistem altyapısı ve işlem mantığı'
        },
        {
          name: 'İzmexCarbon',
          category: 'ESG & Veri',
          description: 'Veri odaklı ESG & karbon analiz sistemi'
        },
        {
          name: 'İzmexMedia',
          category: 'Platform',
          description: 'Dijital platform & iş yönetim sistemi'
        }
      ]
    },
    about: {
      title: 'Hakkımızda',
      description: 'DATEX SYSTEMS, yüksek karmaşıklıkta dijital sistemler kurmaya odaklanmış mühendislik odaklı bir yazılım şirketidir. Deneyimimiz finansal sistemler, algoritmik mantık ve dijital varlık piyasa yapılarını kapsar — hem geleneksel hem de gelişen piyasalar için sağlam mimariler tasarlamamızı sağlar.',
      stats: [
        { value: '10+', label: 'Tamamlanan Proje' },
        { value: 'AI', label: 'Odaklı Geliştirme' },
        { value: '3', label: 'Dil Desteği' }
      ]
    },
    engagement: {
      title: 'Çalışma Felsefemiz',
      subtitle: 'Yazılımı tek seferlik projeler değil, gelişen sistemler olarak ele alıyoruz.',
      items: [
        'Strateji & Sistem Tasarımı',
        'Mimari & Mantık Modelleme',
        'İteratif Geliştirme & Doğrulama',
        'Uzun Vadeli Evrim & Optimizasyon'
      ]
    },
    contact: {
      title: 'Projenizi Konuşalım',
      subtitle: 'Yeni bir SaaS ürünü, MVP veya AI destekli sistem geliştirmeyi mi planlıyorsunuz?',
      cta: 'İletişime Geçin',
      email: 'E-posta',
      address: 'Adres',
      companyName: 'Datex Bilişim AŞ',
      addressLine: 'Çınar Mah. 5003/2 Sokak No: 3-5\nİç Kapı No: 508, Bornova, İzmir'
    },
    footer: {
      rights: 'Tüm hakları saklıdır.',
      tagline: 'AI-Powered Software Solutions'
    }
  },
  en: {
    nav: {
      expertise: 'Expertise',
      caseStudies: 'Case Studies',
      insights: 'Insights',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      headline: 'We Turn Ideas',
      headlineHighlight: 'Into Intelligent',
      headlineSuffix: 'Software',
      tagline: '',
      subtext: 'AI-powered SaaS products, MVPs and business platforms. Built for startups and enterprises.',
      cta1: 'View Case Studies',
      cta2: 'Contact Us'
    },
    value: {
      title: 'Value Proposition',
      description: 'DATEX SYSTEMS is an engineering-driven software company specializing in AI systems, financial software, and scalable business platforms. We don\'t just build software — we solve business logic.'
    },
    expertise: {
      title: 'Our Expertise',
      subtitle: 'We build AI-powered systems that solve complex business problems.',
      items: [
        {
          title: 'AI & Prediction Systems',
          description: 'Probabilistic models, forecasting engines, and decision-support architectures.'
        },
        {
          title: 'SaaS & MVP Development',
          description: 'From concept validation to production-grade scalable systems.'
        },
        {
          title: 'Financial Software',
          description: 'Risk modeling, algorithmic logic, and data-intensive architectures.'
        },
        {
          title: 'Digital Asset & Trading Systems',
          description: 'Trading logic, execution flows, and risk-aware architectures for digital markets.'
        },
        {
          title: 'Analytics & Dashboards',
          description: 'Real-time intelligence and decision-support interfaces.'
        },
        {
          title: 'AI & LLM Integrations',
          description: 'GPT/LLM-powered reasoning and context-aware system design.'
        }
      ]
    },
    focusAreas: {
      title: 'Domains & Specialization',
      subtitle: 'We operate at the intersection of AI, financial systems, and data-driven business platforms.',
      items: ['AI & Prediction Systems', 'Financial & Trading Technologies', 'Digital Asset Markets', 'Data & Analytics']
    },
    caseStudies: {
      title: 'Real Systems.',
      titleHighlight: 'Real Solutions.',
      subtitle: 'Platforms and AI-powered software solutions we\'ve built across different industries.',
      projects: [
        {
          name: 'Borsamex',
          category: 'AI & Finance',
          description: 'AI-powered financial forecasting platform'
        },
        {
          name: 'DatexTrader',
          category: 'Fintech',
          description: 'Financial system architecture'
        },
        {
          name: 'İzmexCarbon',
          category: 'ESG & Data',
          description: 'ESG & data analytics platform'
        },
        {
          name: 'İzmexMedia',
          category: 'Platform',
          description: 'Business & workflow system'
        }
      ]
    },
    about: {
      title: 'About Us',
      description: 'DATEX SYSTEMS is an engineering-driven software company focused on building high-complexity digital systems. Our experience spans financial systems, algorithmic logic, and digital asset market structures — allowing us to design robust architectures for both traditional and emerging markets.',
      stats: [
        { value: '10+', label: 'Projects Delivered' },
        { value: 'AI', label: 'Focused Development' },
        { value: '3', label: 'Languages Supported' }
      ]
    },
    engagement: {
      title: 'Engagement Philosophy',
      subtitle: 'We approach software as evolving systems, not one-time projects.',
      items: [
        'Strategy & System Design',
        'Architecture & Logic Modeling',
        'Iterative Development & Validation',
        'Long-Term Evolution & Optimization'
      ]
    },
    contact: {
      title: 'Let\'s Build Something Intelligent',
      subtitle: 'Planning an MVP, SaaS platform or AI-powered system?',
      cta: 'Contact Us',
      email: 'Email',
      address: 'Address',
      companyName: 'Datex Bilişim AŞ',
      addressLine: 'Çınar Mah. 5003/2 Sokak No: 3-5\nİç Kapı No: 508, Bornova, Izmir, Turkey'
    },
    footer: {
      rights: 'All rights reserved.',
      tagline: 'AI-Powered Software Solutions'
    }
  },
  de: {
    nav: {
      expertise: 'Expertise',
      caseStudies: 'Referenzen',
      insights: 'Insights',
      about: 'Über Uns',
      contact: 'Kontakt'
    },
    hero: {
      headline: 'Wir verwandeln Ideen',
      headlineHighlight: 'in intelligente',
      headlineSuffix: 'Software',
      tagline: '',
      subtext: 'KI-gestützte SaaS-Produkte, MVPs und Business-Plattformen. Für Startups und Unternehmen.',
      cta1: 'Referenzen ansehen',
      cta2: 'Kontakt aufnehmen'
    },
    value: {
      title: 'Wertversprechen',
      description: 'DATEX SYSTEMS ist ein ingenieurgetriebenes Softwareunternehmen mit Fokus auf KI-Systeme, Finanzsoftware und skalierbare Plattformen. Wir entwickeln nicht nur Software — wir lösen Geschäftslogik.'
    },
    expertise: {
      title: 'Unsere Expertise',
      subtitle: 'Wir entwickeln KI-gestützte Systeme, die komplexe Geschäftsprobleme lösen.',
      items: [
        {
          title: 'KI & Prognosesysteme',
          description: 'Probabilistische Modelle, Prognose-Engines und Entscheidungsarchitekturen.'
        },
        {
          title: 'SaaS & MVP Entwicklung',
          description: 'Von der Konzeptvalidierung zu produktionsreifen skalierbaren Systemen.'
        },
        {
          title: 'Finanzsoftware',
          description: 'Risikomodellierung, algorithmische Logik und datenintensive Architekturen.'
        },
        {
          title: 'Digital Asset & Trading-Systeme',
          description: 'Trading-Logik, Ausführungsabläufe und risikobewusste Architekturen für digitale Märkte.'
        },
        {
          title: 'Analytics & Dashboards',
          description: 'Echtzeit-Intelligence und Entscheidungsunterstützungs-Interfaces.'
        },
        {
          title: 'KI & LLM Integrationen',
          description: 'GPT/LLM-gestützte Reasoning- und kontextbewusste Systemarchitektur.'
        }
      ]
    },
    focusAreas: {
      title: 'Domänen & Spezialisierung',
      subtitle: 'Wir arbeiten an der Schnittstelle von KI, Finanzsystemen und datengesteuerten Geschäftsplattformen.',
      items: ['KI & Prognosesysteme', 'Finanz- & Trading-Technologien', 'Digital Asset Märkte', 'Daten & Analytics']
    },
    caseStudies: {
      title: 'Echte Systeme.',
      titleHighlight: 'Echte Lösungen.',
      subtitle: 'Plattformen und KI-gestützte Softwarelösungen, die wir in verschiedenen Branchen entwickelt haben.',
      projects: [
        {
          name: 'Borsamex',
          category: 'KI & Finanzen',
          description: 'KI-gestützte Finanzprognoseplattform'
        },
        {
          name: 'DatexTrader',
          category: 'Fintech',
          description: 'Finanzsystem-Architektur'
        },
        {
          name: 'İzmexCarbon',
          category: 'ESG & Daten',
          description: 'ESG & Datenanalyseplattform'
        },
        {
          name: 'İzmexMedia',
          category: 'Plattform',
          description: 'Business & Workflow-System'
        }
      ]
    },
    about: {
      title: 'Über Uns',
      description: 'DATEX SYSTEMS ist ein ingenieurgetriebenes Softwareunternehmen, das sich auf den Aufbau hochkomplexer digitaler Systeme konzentriert. Unsere Erfahrung umfasst Finanzsysteme, algorithmische Logik und Digital-Asset-Marktstrukturen — so können wir robuste Architekturen für traditionelle und aufkommende Märkte entwerfen.',
      stats: [
        { value: '10+', label: 'Projekte geliefert' },
        { value: 'KI', label: 'Fokussierte Entwicklung' },
        { value: '3', label: 'Sprachen unterstützt' }
      ]
    },
    engagement: {
      title: 'Engagement-Philosophie',
      subtitle: 'Wir betrachten Software als sich entwickelnde Systeme, nicht als einmalige Projekte.',
      items: [
        'Strategie & Systemdesign',
        'Architektur & Logikmodellierung',
        'Iterative Entwicklung & Validierung',
        'Langfristige Evolution & Optimierung'
      ]
    },
    contact: {
      title: 'Lassen Sie uns etwas Intelligentes bauen',
      subtitle: 'Planen Sie ein MVP, eine SaaS-Plattform oder ein KI-System?',
      cta: 'Kontaktieren Sie uns',
      email: 'E-Mail',
      address: 'Adresse',
      companyName: 'Datex Bilişim AŞ',
      addressLine: 'Çınar Mah. 5003/2 Sokak No: 3-5\nİç Kapı No: 508, Bornova, Izmir, Türkei'
    },
    footer: {
      rights: 'Alle Rechte vorbehalten.',
      tagline: 'KI-gestützte Softwarelösungen'
    }
  }
};